import useBreakpoint from "./useBreakpoint";
import logoCollor from './logo_collor.svg';
import { Button, Container, Form, Nav, NavDropdown, Navbar, Offcanvas } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import { useState } from "react";

const Header = ({ onLogout, isAuthenticated }) => {
  const [size] = useBreakpoint();
  const navigate = useNavigate();
  const [expand, setExpand] = useState(false);
  // todo change login page
  const handleLoginClick = () => {
    // Navigate to login page
    navigate('/login');
  };

  return (
    <> {(size !== "xs" && size !== "sm" && size !== "md") && ( <>
      <header
        className={
          size === "lg" || size === "xl"
            ? "d-flex justify-content-between pt-xxl-5"
            : "d-flex justify-content-between pt-xxl-2 pb-2"
        }
        style={{background: "white", color: "black"}}
      >
        <div className="align-items-center">
          {isAuthenticated ? <Navbar key={false} expand={false} collapseOnSelect>
            <Container fluid>
              <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${false}`}/>
              <Navbar.Brand style={{cursor: "pointer"}}><img src={logoCollor} alt="logo" style={{width: 200}}/></Navbar.Brand>
              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-${false}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${false}`}
                placement="start"
                style={{width: 300, background: "black", color: "white"}}
              >
                <Offcanvas.Header closeButton style={{background: "white"}}>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 pe-3">
                    <Nav.Link eventKey="1" as={Link} to="/my-evaluations">My evaluations</Nav.Link>
                    <Nav.Link eventKey="1" as={Link} to="/all-evaluations">All evaluations</Nav.Link>
                    <Nav.Link eventKey="2" as={Link} to="/my-account">My account</Nav.Link>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
          : <img src={logoCollor} alt="logo" style={{width: 200}}/>}
        </div>
        <div className="flex-grow-1 align-items-center">
        </div>
        <div className="flex-grow-1 align-items-center">
        </div>
        <div className="d-flex flex-grow-1 align-items-center">
          <div className="d-flex justify-content-between flex-grow-1 align-items-center">
                <span>
                  <div className="vl"></div>
                </span>
            <span className="d-flex align-items-start" style={{fontWeight: 700, fontSize: 15, cursor: "pointer"}} onClick={() => navigate("/about")}>
                  ABOUT
                </span>
            <span className="align-items-end"  style={{fontWeight: 700, fontSize: 15}}>
                  {isAuthenticated ? (
                    <span onClick={onLogout} style={{ cursor: 'pointer' }}>LOG OUT</span>
                  ) : (
                    <span onClick={handleLoginClick} style={{ cursor: 'pointer' }}>LOG IN</span>
                  )}
                </span>
            <span>
                  <div className="vl"></div>
                </span>
          </div>
        </div>
      </header>
    </>)}
      {(size === "xs" || size === "sm" || size === "md") && ( <>
        <Navbar key={false} expand={false} collapseOnSelect className="bg-body-tertiary mb-3">
          <Container fluid>
            <Navbar.Brand href="#"><img src={logoCollor} alt="logo" style={{width: 200}}/></Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${false}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${false}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${false}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="justify-content-end flex-grow-1 pe-3">
                    <Nav.Link eventKey="1" as={Link} to="/my-evaluations">My evaluations</Nav.Link>
                    <Nav.Link eventKey="1" as={Link} to="/all-evaluations">All evaluations</Nav.Link>
                    <Nav.Link eventKey="2" as={Link} to="/my-account">My account</Nav.Link>
                  </Nav>
                </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </> )}
    </>
  );
};

export default Header;
